import { useEffect, useRef, useState } from 'react';
import './LoginFormTabs.css';

interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface Props {
  tabs: Tab[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

export const LoginFormTabs = ({ tabs, activeTab, onTabChange }: Props) => {
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const [hasInteracted, setHasInteracted] = useState(false);
  const tabsRef = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    const tabEl = tabsRef.current[activeTab];
    if (tabEl) {
      const { offsetLeft, offsetWidth } = tabEl;
      setIndicatorStyle({
        left: offsetLeft + offsetWidth / 2 - 20,
        width: 40,
      });
    }
  }, [activeTab]);

  return (
    <div className="tab-container">
      <div className="tab-list">
        {tabs.map(({ id, label }, i) => (
          <button
            key={id}
            ref={(el) => {
              tabsRef.current[i] = el;
            }}
            className={`tab ${activeTab === i ? 'active' : ''}`}
            onClick={() => {
              onTabChange(i);
              setHasInteracted(true);
            }}
          >
            {label}
          </button>
        ))}

        {/* The moving indicator */}
        <span
          className="tab-indicator"
          style={{
            left: indicatorStyle.left,
            width: indicatorStyle.width,
            transition: hasInteracted ? 'left 0.3s ease, width 0.3s ease' : 'none',
          }}
        />
      </div>
    </div>
  );
};
